import React, {memo, useEffect, useState} from 'react';
import {StyleSheet, Text, View} from 'react-native';

import {makeStyles, Overlay} from 'react-native-elements'; // rne-netzon replaced

import {RNEButton, RNEText} from '../../components';
import {ConsultationVideoCallScreen} from '../../screens';
import {ConsultationRequestResBody} from '../../server/types/consultation.types';
import useStores from '../../stores/useStores';
import {CodedConversationMessages} from '../../server/types/conversation.types';
import {width, height, totalSize} from 'react-native-dimension';
import {Pressable} from 'react-native';
import moment from 'moment';
import {NavigationKey} from '../../navigations/config';
import {colorPalette} from '../../../core/config/color.config';
import {Icon} from 'react-native-elements'; // rne-netzon replaced
import {useNavigation} from '@react-navigation/native';

export interface ConsultationMessageBubbleProps {
  message: string;
  timestamp: Date;
  owner?: boolean;
  isPatient?: boolean;
  serviceRequest?: ConsultationRequestResBody;
  latestVideoCallRequestTimestamp?: Date;
  onStartGenerating: () => void;
  onStopGenerating: () => void;
}

const ConsultationMessageVideoCallBubble = (
  props: ConsultationMessageBubbleProps,
) => {
  const navigation = useNavigation();

  const {authStore, conversationStore} = useStores();

  const [showVideoCallDialog, setShowVideoCallDialog] = useState(false);
  const [displayMessage, setDisplayMessage] = useState('');

  const acceptCall = () => {
    setShowVideoCallDialog(true);
    const audio = document.getElementById(
      'ringingNotification',
    ) as HTMLAudioElement;
    audio.muted = true;
    audio.pause();
  };

  useEffect(() => {
    if (
      !props.owner &&
      props.message === CodedConversationMessages.VIDEO_CALL_TRIGGER
    ) {
      conversationStore.setLatestVideoCallRequest(props);
    }

    switch (props.message) {
      case CodedConversationMessages.VIDEO_CALL_TRIGGER:
        setDisplayMessage(
          props.owner
            ? `You have invited the ${
                props.isPatient ? 'doctor' : 'patient'
              } to a video call.`
            : `The ${
                props.isPatient ? 'patient' : 'doctor'
              } has invited you to a video call.`,
        );
        break;

      case CodedConversationMessages.VIDEO_CALL_ACCEPT:
        setDisplayMessage(
          props.owner
            ? `You have accepted the invitation for a video call with the ${
                props.isPatient ? 'doctor' : 'patient'
              }.`
            : `The ${
                props.isPatient ? 'patient' : 'doctor'
              } has accepted your invitation for a video call.`,
        );
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);


  return (
    <>
      <View
        style={{
          marginBottom: totalSize(2),
          marginTop: totalSize(2.5),
          alignContent: 'center',
          alignItems: 'center',
          padding: totalSize(1),
          width: width(90),
        }}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: totalSize(6),
          }}>
          <Icon
            type="material-community"
            name="calendar"
            color={colorPalette.secondary}
            size={totalSize(6.5)}
          />
          <View style={{alignContent: 'flex-end', alignItems: 'flex-end'}}>
            <Text
              style={{
                fontSize: totalSize(1.6),
                fontFamily: 'Quicksand-Bold',
              }}>
              Online consultation appointment
            </Text>
            <Text
              style={{
                fontSize: totalSize(1.6),
                fontFamily: 'Quicksand-Medium',
              }}>
              {serviceRequest?.patient?.firstName} {serviceRequest?.patient?.lastName}
            </Text>
          </View>
        </View>

        <Pressable
          onPress={() => {
            // navigation.navigate('ConsultationVideoCall');
            // navigation.navigate(NavigationKey.CONSULTATION_VIDEO_CALL);
          }}>
          <View
            style={{
              backgroundColor: colorPalette.primary,
              width: width(100),
              padding: totalSize(1.5),
              borderRadius: totalSize(0),
              marginTop: totalSize(1),
            }}>
            <Text
              style={{
                fontSize: totalSize(1.5),
                fontFamily: 'Quicksand-Bold',
                color: colorPalette.white,
                textAlign: 'center',
              }}>
              Attend Consultation
            </Text>
          </View>
        </Pressable>

        <View
          style={{
            backgroundColor: colorPalette.secondary,
            width: width(100),
            padding: totalSize(1.5),
            borderRadius: totalSize(0),
            marginTop: totalSize(0.5),
          }}>
          <Text
            style={{
              fontSize: totalSize(1.5),
              fontFamily: 'Quicksand-Bold',
              color: colorPalette.white,
              textAlign: 'center',
            }}>
            Close Consultation
          </Text>
        </View>
      </View>
    </>
  );

  // return (
  //   <View>
  //     <Overlay isVisible={showVideoCallDialog}>
  //       <ConsultationVideoCallScreen
  //         procedureId={props.serviceRequest?.procedure?.procedureId || ''}
  //         subjectId={
  //           authStore.userRole === 'patient'
  //             ? props.serviceRequest?.subject.patientId!
  //             : ''
  //         }
  //         receiver={
  //           authStore.userRole === 'patient'
  //             ? props.serviceRequest?.performer!
  //             : props.serviceRequest?.subject!
  //         }
  //         fromInvitation={true}
  //         onConfirm={() => setShowVideoCallDialog(false)}
  //       />
  //     </Overlay>
  //     <RNEText label={displayMessage} color="white" variant="button" />
  //     {!props.owner &&
  //       props.message === CodedConversationMessages.VIDEO_CALL_TRIGGER && (
  //         <RNEButton
  //           title="Accept"
  //           color="accent"
  //           style={styles.buttonStyle}
  //           onPress={acceptCall}
  //           disabled={props.timestamp !== props.latestVideoCallRequestTimestamp}
  //         />
  //       )}
  //   </View>
  // );
};

const styles = StyleSheet.create({
  buttonStyle: {
    padding: 8,
  },
});

export default memo(ConsultationMessageVideoCallBubble);
